import React from 'react'
import { IonCol, IonGrid, IonItemDivider, IonLabel, IonList, IonRow } from '@ionic/react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import MultiSelect from '../../../components/multiSelect/MultiSelect.component'
import { IRootState } from '../../../store'
import { getCmsInformationOptionsSelector } from '../../options/selectors/cmsInformationOptions.selector'
import {
  saveCmsInformation,
  setCmsConditionCode,
  setConditionCodeModifier,
  setCmsTransportReason,
  setAmbulanceConditionIndication,
} from '../store/cmsInformation.actions'
import useDeviceMetrics from '../../../utilities/useDeviceMetrics'

const CmsInformationContent: React.FC = () => {
  const { t } = useTranslation()
  const { isTablet } = useDeviceMetrics()
  const cmsInformationOptions = useSelector(getCmsInformationOptionsSelector)
  const {
    filteredCmsConditionCodeOptions,
    conditionCodeModifierOptions,
    cmsTransportReasonOptions,
    ambulanceConditionIndicatorOptions,
  } = cmsInformationOptions

  const cmsInformation = useSelector((state: IRootState) => state.cmsInformation)
  const { cmsConditionCode, cmsTransportReason, conditionCodeModifier, ambulanceConditionIndication } = cmsInformation

  return (
    <>
      <IonItemDivider color='light' className='ion-padding'>
        <IonLabel className='grid-item-divider-label' color='medium'>
          {t('cmsInformation.cmsInformationDetails')}
        </IonLabel>
      </IonItemDivider>
      <IonList className={isTablet ? 'ion-margin-horizontal' : ''}>
        <IonGrid className='ion-no-padding'>
          <hr className='field-divider' />
          <IonRow>
            <IonCol className='picklist'>
              <MultiSelect
                dataTestID='CMSConditionCode'
                listHeader={t('cmsInformation.cmsConditionCode')}
                options={filteredCmsConditionCodeOptions}
                savedValues={cmsConditionCode}
                action={setCmsConditionCode}
                callback={saveCmsInformation}
                label={t('cmsInformation.cmsConditionCode')}
              />
            </IonCol>
          </IonRow>
          <hr className='field-divider' />
          <IonRow>
            <IonCol className='picklist'>
              <MultiSelect
                dataTestID='ConditionCodeModifier'
                listHeader={t('cmsInformation.conditionCodeModifier')}
                options={conditionCodeModifierOptions}
                savedValues={conditionCodeModifier}
                action={setConditionCodeModifier}
                callback={saveCmsInformation}
                label={t('cmsInformation.conditionCodeModifier')}
              />
            </IonCol>
          </IonRow>
          <hr className='field-divider' />

          <IonRow>
            <IonCol className='picklist'>
              <MultiSelect
                dataTestID='CMSTransportReason'
                listHeader={t('cmsInformation.cmsTransportReason')}
                options={cmsTransportReasonOptions}
                savedValues={cmsTransportReason}
                action={setCmsTransportReason}
                callback={saveCmsInformation}
                label={t('cmsInformation.cmsTransportReason')}
              />
            </IonCol>
          </IonRow>
          <hr className='field-divider' />

          <IonRow>
            <IonCol className='picklist'>
              <MultiSelect
                dataTestID='AmbulanceConditionIndicator'
                listHeader={t('cmsInformation.ambulanceConditionIndicator')}
                options={ambulanceConditionIndicatorOptions}
                savedValues={ambulanceConditionIndication}
                action={setAmbulanceConditionIndication}
                callback={saveCmsInformation}
                label={t('cmsInformation.ambulanceConditionIndicator')}
              />
            </IonCol>
          </IonRow>
          <hr className='field-divider' />
        </IonGrid>
      </IonList>
    </>
  )
}

export default CmsInformationContent
